var CustomerEmailView = (function (app, CheckoutApiModel) {

    var consent = $('[id$="siteData"]').data('consent');

    function validateEmail(email) {
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    var customerEmailModel = CheckoutApiModel.extend({
        defaults: {
            email: null,
            tc: consent.RATermsAndConditionCheckboxTicked || null,
            id: null,
            emailAccept: consent.RAReceiveEmailsCheckboxTicked || null
        },
        getID: function () {
            return this.get('id');
        },
        getEmail: function () {
            return this.get('email');
        },
        getEmailAccept: function () {
            return this.get('emailAccept');
        },
        getTC: function () {
            return this.get('tc');
        },
        setID: function () {
            return this.get('id');
        },
        setEmail: function (value, id) {
            return this.set({ email: value, id: id });
        },
        setEmailAccept: function (value, id) {
            return this.set({ emailAccept: value, id: id });
        },
        setTC: function (value, id) {
            return this.set({ tc: value, id: id });
        },
        getValidatedEmail: function () {
            if (validateEmail(this.getEmail())) {
                return this.getEmail();
            }
            return null;
        }
    });

    var _model = null;

    var _getModel = function () {
        if (_model === null) {
            _model = new customerEmailModel();
            app.customerEmailModel = _model;
        }
        return _model;
    }

    return Backbone.View.extend({

        events: {
            'keyup input': '_validate',
            'focus input': '_focus',
            'mouseup input': '_clearedByCross'
        },

        initialize: function (opts) {
            _.bindAll(this);

            this.model = _getModel();

            if (this.model._isAuthorized() || !app.settings.get('UseGuestCheckout')) {
                this.$el.remove();
            } else {

                if (!opts.onlyButtons) {
                    var tmpl = $.tmpl('bt-checkout-customer-email');
                    this.$el.html(tmpl);

                    // text about login
                    // ReSharper disable once WrongExpressionStatement
                    !function (t) {

                        var loginLinkHtml = '<a class="login-anon-checkout-text_link test_guest_display_login_form" href="#" onClick="window.__login_anon_checkout__()">Log In</a>';
                        var htmlTemplate = kos.getPageTemplate('_GuestCheckoutLoginDescription').replace(/\[\[log in\]\]/gi, loginLinkHtml);

                        t.$el.append($('<div class="login-anon-checkout-text">' + htmlTemplate + '</div>'));

                        window.__login_anon_checkout__ = function () {
                            window.app && app.event && app.event.logIn();
                            window.landingFormShow({ mode: 'Login' }).done(function () {
                                document.location.href = '/Checkout.aspx';
                            });
                            eventEmitter.trigger('changeLeftButton',
                                {
                                    func: function () {
                                        document.location.href = '/Checkout.aspx';
                                    }
                                });
                        };
                    }(this);
                }

                this.$el.addClass('customerEmail-wrapper');


                if (!opts.onlyEmail) {
                    this.switchTC = new Switch({
                        defaultValue: consent.RATermsAndConditionCheckboxTicked || null,
                        trueText: kos.getPageTemplate('js_Yes'),
                        falseText: kos.getPageTemplate('js_No'),
                        label: kos.getPageTemplate('_consentWithTCText'),
                        testClass: 'test-guest-tac-switch',
                        onChanged: this._switchChanged
                    });

                    this.switchEmailPromo = new Switch({
                        defaultValue: consent.RAReceiveEmailsCheckboxTicked || null,
                        trueText: kos.getPageTemplate('js_Yes'),
                        falseText: kos.getPageTemplate('js_No'),
                        label: kos.getPageTemplate('_consentWithEmailsText'),
                        testClass: 'test-guest-emails-switch',
                        onChanged: this._switchChangedEmail
                    });

                    this.switchTC.appendTo(this.$el);
                    this.switchEmailPromo.appendTo(this.$el);
                }

                if (!opts.onlyButtons) {
                    this.$field = this.$('input');
                }

                if (!opts.onlyButtons) {
                    this.model.on('change:email', this._update);
                }
                if (!opts.onlyEmail) {
                    this.model.on('change:tc', this._update);
                    this.model.on('change:emailAccept', this._update);
                }
            }
        },

        _update: function (m) {
            var id = this.model.getID();
            if (id !== this.cid) {
                this.$field && this.$field.val(m.getEmail());
                this.switchTC && this.switchTC.setValueNoCast(m.getTC());
                this.switchEmailPromo && this.switchEmailPromo.setValueNoCast(m.getEmailAccept());
                this.$field && this.$field.toggleClass('errorField', !validateEmail(this.$field.val()));
            }
        },

        _switchChanged: function (val) {
            if (this.switchTC) {
                if (window.__promoTC__ !== val) {
                    window.__promoTC__ = val;
                    window.app && app.event && app.event.userAgreementsTermsAndCondition(val);
                }
                val !== null && this.model.setTC(val, this.cid);
            }
        },

        _switchChangedEmail: function (val) {
            if (this.switchEmailPromo) {

                if (window.__promoVal__ !== val) {
                    window.__promoVal__ = val;
                    window.app && app.event && app.event.userAgreementsReceivePromotional(val);
                }
                val !== null && this.model.setEmailAccept(val, this.cid);
            }
        },

        _validate: function (e) {
            var val = this.$field.val();
            this.$field && this.$field.toggleClass('errorField', !validateEmail(val));
            val !== null && this.model.setEmail(val, this.cid);
        },


        _focus: function () {
            this.$field && this.$field.removeClass('errorField');
        },

        _clearedByCross: function (e) {
            var _this = this;
            if (e.currentTarget.value === "") return;
            setTimeout(function () {
                if (e.currentTarget.value === "") _this._validate();
            }, 0);
        },

        getCustomerEmail: function () {
            var result = this._validate();
            return !result && null || this.$field.val();
        }
    });

})(app, CheckoutApiModel);